<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :enable-download="false"
      :preview-modal="false"
      :paginate-elements-by-height="1200"
      :filename= "nomeArquivo"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      :pdf-margin="10"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @beforeDownload="abrirNovaGuia"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="conteiner_pdf_grafico">
          <div class="pdf-header">
            <div class="nome_relatorio-pdf">
              Relatório APR - {{ ' ' + dataFormatada}}
            </div>
          </div>
        </div>

        <div class="filtro_parametros-pdf">
         <div class="report-filter">
                <div class="filtro_parametros-peq">
                    <div class="filter-text">
                        <div class="border-filter">
                        <i class="fas fa-filter icon-filter d- mr-2 ml-2"></i>
                        </div>
                        <div class="header_filtro" style="width: 100%;">Filtros Utilizados</div>
                        <div class="periodo_filtro" v-if="filtros.statusAPR != null" style="margin-bottom: 1rem; display: flex; width: 100%; justify-content: end; margin-right: 1rem;">
                            <div :style="{'background-color': filtros.backcolor, 'color': filtros.color, 'border-radius': '10px', 'height': 'fit-content', 'padding': '0.3rem', 'padding-left': '0.5rem','padding-right': '0.5rem', 'width': 'fit-content'}">{{filtros.statusAPR}}</div>
                        </div>
                    </div>
                    <div class="container_header_filtro_periodo_atividade">
                        <div class="status_filtro">
                        Atividade:  <strong class="filtrostatus">{{filtros.atividade == null ? "Todas" : filtros.atividade}}</strong>
                        </div>
                        <div class="periodo_filtro">
                        Período:  <strong class="filtrostatus">{{(filtros.dataInicio == null || filtros.dataInicio == '' ?  "N/D" : filtros.dataInicio) + ' - ' + (filtros.dataFim == null || filtros.dataFim == '' ?  "N/D" : filtros.dataFim)  }} </strong>
                        </div>
                    </div>
                    <div class="container_header_filtro">
                        <div class="periodo_filtro">
                            Responsável:  <strong  class="filtrostatus">{{filtros.responsavel == null || filtros.codigoAPR == ''  ?  "N/D" : filtros.responsavel}}</strong>
                        </div>
                        <div class="periodo_filtro">
                        Código:  <strong  class="filtrostatus">{{filtros.codigoAPR == null || filtros.codigoAPR == '' ?  "N/D" : filtros.codigoAPR}}</strong>
                        </div>
                    </div>
                </div>
                <div class="report-qta">
                    <div class="numerochamados">
                        <div class="qtachamado">
                            {{quantitativos.apr == null ? 0 : quantitativos.apr }}
                        </div>
                        <div class="text-filter">
                            Total APR's
                        </div>
                    </div>
                    <div class="numerochamados">
                        <div class="qtachamado">
                            {{quantitativos.aprPendetes == null ? 0 : quantitativos.aprPendetes }}
                        </div>
                        <div class="text-filter">
                            APRS Pendentes
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div v-for="(group, index) in groupedData" :key="index" class="container_pdffiltro"> -->
            <div class="container_pdffiltro">
                <div class="container_ocorrencias_filtradas">
                    <div class="codigo_apr font">Código</div>
                    <div class="area_apr font">Área</div>
                    <div class="responsavel_apr font">Responsável</div>
                    <div class="responsavel_apr font">Status</div>
                    <div class="dataInicio_apr font">Data Execução</div>
                    <div class="dataFim_apr font">Data Validade</div>
                </div>
                <div class="container_ocorrencias" v-for=" obj in dados" :key="obj.id">
                    <div class="codigo_apr_result font_result">{{obj.codigoAPR}}</div>
                    <div class="area_apr_result font_result" style="text-align: center;">{{obj.local}}</div>
                    <div class="responsavel_apr_result font_result" style="text-align: center;">{{ obj.nome }}</div>
                    <div class="responsavel_apr_result font_result" style="align-items: center;">
                        <div :style="{'background-color': obj.colorBackgroundStatusApr, 'color': obj.colorFontStatusApr, 'border-radius': '10px', 'height': 'fit-content', 'padding': '0.3rem'}">{{obj.statusAPRDescricao}}</div>
                    </div>
                    <div class="dataInicio_apr_result font_result" style="align-items: center;">{{obj.dataAPRFormatada}}</div>
                    <div class="dataFim_apr_result font_result" style="align-items: center;">{{obj.dataAPRValidadeFormatada}}</div>
                </div>
            </div>
        </div>

    </section>
    </vue-html2pdf>
  </div>

</template>

<script>
import aprReportPdf from './aprReportPdf'
export default aprReportPdf
</script>

<style scoped>

.conteiner_pdf_grafico{
    padding: 0.5rem;
}
.filtro_parametros-pdf{
    width: 100%;
    padding: 0.5rem;
    height: fit-content;
    border-radius: 5px;
}
.pdf-header{
    margin-bottom: 0.5rem;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.nome_relatorio-pdf {
    display: flex;
    width: 100%;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    color: rgb(54, 54, 54);
    font-family:'Poppins';
    margin-bottom: 1rem;
    background: transparent;
}
.report-filter{
    padding: 0.5rem;
    display: flex;
    gap: 1rem;
}
.filtro_parametros-peq{
    width: 100%;
    border-radius: 10px;
    background: #F4F4F4;
}
.filter-text{
    display:flex;
    align-items: center;
    padding: 1rem 0 0 1rem;
}
.border-filter{
    border-radius: 5px;
    background: #E8E8E8;
    width: 23px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right:1rem;
}
.icon-filter{
    color:#2E973D;
}
.header_filtro{
    color: #1A1818;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    font-family: 'Poppins';
}
.container_header_filtro_periodo_atividade{
    display: flex;
    padding: 1rem;
    gap: 1rem;
}
.status_filtro {
    color: #1A1818;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    font-family: 'Poppins';
}
.periodo_filtro {
    color: #1A1818;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    font-family: 'Poppins';
}
.container_header_filtro{
    display: flex;
    padding: 0 1rem 0 1rem;
    flex-direction: column;
    gap: 1rem;
}
.header_filtro{
    color: #1A1818;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    font-family: 'Poppins';
}
.filtro_parametros{
    margin-top: 2rem;
    width: 100%;
    height: fit-content;
    background: rgb(236, 236, 236);
    border-radius: 5px;
    padding: 0.5rem
}
.report-qta{
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}
.numerochamados{
    width: 215px;
    height: 6rem;
    border-radius: 10px;
    background: #F4F4F4;
    padding: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.qtachamado{
    color: #008148;
    text-align: center;
    font-family: 'Poppins';
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 27px;
}
.text-filter{
    color: #1A1818;
    text-align: center;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
}
.text-filter-small{
    color: #1A1818;
    text-align: center;
    font-family: 'Poppins';
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
}
.container_pdffiltro{
    margin-top: 2rem;
    width: 100%;
    padding: 1rem;
    border-radius: 10px;
}
.container_ocorrencias_filtradas{
    width: 100%;
    height: 2rem;
    border-radius: 5px 5px 0 0;
    background: #2E973D;
    display: flex;
    justify-content: space-around;
    align-items: center;
    break-before: avoid;
}
.container_ocorrencias_filtradas > div {
    width: calc(20% - 10px);
}
.container_ocorrencias_filtradas > .codigo_apr, .codigo_apr_result   {
    margin: 5px;
}
.container_ocorrencias_filtradas > .area_apr, .area_apr_result   {
    display: flex;
    justify-content: center;
    margin: 5px;
}
.container_ocorrencias_filtradas > .dataFim_apr, .dataFim_apr_result   {
    display: flex;
    justify-content: center;
    margin: 5px;
}
.container_ocorrencias_filtradas > .dataInicio_apr, .dataInicio_apr_result   {
    display: flex;
    justify-content: center;
    margin: 5px;
}
.container_ocorrencias_filtradas > .responsavel_apr, .responsavel_apr_result   {
    display: flex;
    justify-content: center;
    margin: 5px;
}
.container_ocorrencias_filtradas >
.descricao_oce_result,
.descricao_oce {
    width: 60% !important;
    margin: 5px;
}
.container_ocorrencias_filtradas,
.enterprise-report,
.container_ocorrencias_filtradas,
.container_ocorrencias,
.dataFim_apr_result
.dataInicio_apr_result
.responsavel_apr_result
.area_apr_result
.codigo_apr_result
{
    break-inside: avoid;
}
.container_ocorrencias {
    width: 100%;
    display: flex;
    justify-content: center;
    border: #f4f4f4 1px solid
}
.container_ocorrencias > div {
    width: calc(20% - 10px);
    margin: 5px;
}

.font{
    color: #FFF;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
}
.codigo_apr {
    display: flex;
    justify-content: center;
    align-items: center;
}
.container_ocorrencias > .codigo_apr,
.codigo_apr_result {
    display: flex;
    justify-content: center;
    margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/aprReport/components/aprReportTable/components/aprReportPdf/aprReportPdf.vue